'use strict';

import cuentas_bancarias from './CuentasBancarias/cuentasBancariasCtrl';
import perfil_cuenta from './CuentasBancarias/Perfil_Cuenta/perfilCuentaBancariaCtrl';
import traspasos from './Traspasos/traspasosCtrl';
import reexpresiones from './Reexpresiones/reexpresionesCtrl';

export default angular.module('contartemx.bancos', [
    'contartemx.bancos.cuentas_bancarias',
    'contartemx.bancos.cuentas_bancarias.perfil_cuenta',
    'contartemx.bancos.traspasos',
    'contartemx.bancos.reexpresiones',
    'ui.router'
])
    .config(($stateProvider) => {

        $stateProvider.state('bancos', {
            url: '/Bancos',
            abstract: true,
            views:
            {
                'submenu': {
                    template: require('../../../../app/views/Bancos/Bancos_submenu.html'),
                    controller: 'BancosCtrl'
                },
                '': {
                    template: require('../../../../app/views/MainContainer.html'),
                    controller: 'BancosCtrl'
                }
            },
            resolve: {
                authorize: ['authorization', authorization => authorization.authorize()],
            },
            data: { roles: ['Bancos'] }
        })
            .state('bancos.cuentas_bancarias', {
                url: '/CuentasBancarias',
                views:
                {
                    'main': {
                        template: require('../../../../app/views/Bancos/Cuentas_Bancarias/CuentasBancarias_main.html'),
                        controller: 'CuentasBancariasCtrl'
                    }
                },
                data: { roles: ['Bancos_CuentasBancarias'] }
            })
            .state('bancos.cuentas_bancarias.perfil_cuenta', {
                url: '/:cveCuentaBanco',
                views:
                {
                    'main@bancos': {
                        template: require('../../../../app/views/Bancos/Cuentas_Bancarias/PerfilCuenta_main.html'),
                        controller: 'PerfilCuentaCtrl'
                    }
                },
                data: { roles: ['Bancos_CuentasBancarias'] }
            })
            .state('bancos.traspasos', {
                url: '/Traspasos',
                views:
                {
                    'main': {
                        template: require('../../../../app/views/Bancos/Traspasos/Traspasos_main.html'),
                        controller: 'TraspasosCtrl'
                    }
                },
                data: { roles: ['Bancos_Traspasos'] }
            })
            .state('bancos.reexpresiones', {
                url: '/Reexpresiones',
                views:
                {
                    'main': {
                        template: require('../../../../app/views/Bancos/Reexpresiones/Reexpresiones_main.html'),
                        controller: 'ReexpresionesCtrl'
                    }
                },
                data: { roles: ['Bancos_Reexpresiones'] }
            });
    })
    .controller('BancosCtrl', () => {

    });

